export const file = {
	pdf: { name: 'pdf', icon: 'fas fa-file-pdf', color: 'red' },
	doc: { name: 'doc', icon: 'fas fa-file-word', color: 'blue' },
	docx: { name: 'docx', icon: 'fas fa-file-word', color: 'blue' },
	xls: { name: 'xls', icon: 'fas fa-file-excel', color: 'green' },
	xlsx: { name: 'xlsx', icon: 'fas fa-file-excel', color: 'green' },
	ppt: { name: 'ppt', icon: 'fas fa-file-powerpoint', color: 'orange' },
	pptx: { name: 'pptx', icon: 'fas fa-file-powerpoint', color: 'orange' },
	jpg: { name: 'jpg', icon: 'fas fa-file-jpg', color: 'purple' },
	jpeg: { name: 'jpeg', icon: 'fas fa-file-jpg', color: 'purple' },
	png: { name: 'png', icon: 'fas fa-file-png', color: 'purple' },
	gif: { name: 'gif', icon: 'fas fa-file-image', color: 'purple' },
	txt: { name: 'txt', icon: 'fas fa-file', color: 'grey' },
	zip: { name: 'zip', icon: 'fas fa-file-zipper', color: 'yellow' },
	rar: { name: 'rar', icon: 'fas fa-file-zipper', color: 'yellow' },
	default: { name: 'default', icon: 'fas fa-file', color: 'grey' },
}